import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { useForm, Controller } from 'react-hook-form';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import { useTheme } from '@material-ui/core';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import SearchGroupStyled from './SearchGroupStyled';
import ClearIconML from '@/components/ClearIconML/index';
import webStorage from '@/utils/storageManager';

const SearchGroup = React.forwardRef((props) => {
  const { query } = props;
  const { handleSearch, restClick, searchRef } = props;
  const { title, status, updateStrategy, createName, type = '2' } = query;
  const theme = useTheme();
  const GROUP_STATUS = webStorage.get('DICTOBJ')?.GROUP_STATUS;
  const GROUP_TYPE =
    webStorage
      .get('DICTOBJ')
      ?.GROUP_TYPE?.filter((item) => item.dictValue !== 1) || [];
  const GROUP_UPDATE_STRATEGY = webStorage
    .get('DICTOBJ')
    ?.GROUP_UPDATE_STRATEGY.filter((item) => item.dictValue !== 3);

  const { handleSubmit, control, reset, setValue, watch } = useForm({
    defaultValues: {
      title,
      status,
      updateStrategy,
      createName,
      type,
    },
  });
  // 每个输入框清除数据
  //置空状态
  const handleClearStatus = () => {
    setValue('status', '');
  };
  //置空状态
  const handleClearType = () => {
    setValue('type', '');
  };
  // 置空更新方式
  const handleClearUpdateStrategy = () => {
    setValue('updateStrategy', '');
  };
  const watchStatus = watch('status');
  const watchType = watch('type');
  const watchUpdateStrategy = watch('updateStrategy');
  const [titleValue, setTitleValue] = useState();
  const [createByValue, setCreateByValue] = useState();
  //初始状态保持的时候
  useEffect(() => {
    if (title) {
      setTitleValue(title);
    }
    if (createName) {
      setCreateByValue(createName);
    }
  }, [title, createName]);
  //点击搜素
  const handleSubmitSuccess = (submitData) => {
    const propsSubmitData = {
      ...submitData,
    };
    handleSearch && handleSearch(propsSubmitData);
  };
  //点击重置
  const handleRestClick = () => {
    const resetSearch = {
      title: '',
      status: '',
      type: '2',
      updateStrategy: '',
      createName: '',
    };
    setTitleValue('');
    setCreateByValue('');
    reset(resetSearch);
    const propsResetSearch = {
      title: '',
      status: '',
      type: '2',
      updateStrategy: '',
      createName: '',
    };
    restClick && restClick(propsResetSearch);
  };

  return (
    <SearchGroupStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <Box className="card-content">
          <Box className="left">
            <Box className="line" mb={3}>
              <Controller
                render={(rp) => (
                  <TextField
                    name="title"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label="人群名称"
                    defaultValue=""
                    value={rp.value ?? titleValue}
                    onChange={(e) => {
                      setValue('title', e.target.value);
                      setTitleValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('title', '');
                              setTitleValue('');
                            }}
                            edge="end"
                          >
                            {titleValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="title"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label="人群名称"
                defaultValue=""
              />
              <FormControl variant="standard" className="gender">
                <InputLabel>人群类型</InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('type', '')}
                              edge="end"
                            >
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {GROUP_TYPE &&
                        GROUP_TYPE.map((item) => (
                          <MenuItem
                            key={item.dictCode}
                            value={item.dictValue}
                            name={item.nameZh}
                          >
                            {item.nameZh}
                          </MenuItem>
                        ))}
                    </Select>
                  }
                  label="人群类型"
                  name="type"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                <ClearIconML
                  handleClick={handleClearType}
                  clearValue={watchType}
                ></ClearIconML>
              </FormControl>
              <FormControl variant="standard" className="gender">
                <InputLabel>状态</InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('status', '')}
                              edge="end"
                            >
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {GROUP_STATUS &&
                        GROUP_STATUS.map((item) => (
                          <MenuItem
                            key={item.dictCode}
                            value={item.dictValue}
                            name={item.nameZh}
                          >
                            {item.nameZh}
                          </MenuItem>
                        ))}
                    </Select>
                  }
                  label="状态"
                  name="status"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                <ClearIconML
                  handleClick={handleClearStatus}
                  clearValue={watchStatus}
                ></ClearIconML>
              </FormControl>
              <FormControl variant="standard" className="gender">
                <InputLabel>更新方式</InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('updateStrategy', '')}
                              edge="end"
                            >
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {GROUP_UPDATE_STRATEGY &&
                        GROUP_UPDATE_STRATEGY.map((item) => (
                          <MenuItem
                            key={item.dictCode}
                            value={item.dictValue}
                            name={item.nameZh}
                          >
                            {item.nameZh}
                          </MenuItem>
                        ))}
                    </Select>
                  }
                  label="更新方式"
                  name="updateStrategy"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                <ClearIconML
                  handleClick={handleClearUpdateStrategy}
                  clearValue={watchUpdateStrategy}
                ></ClearIconML>
              </FormControl>
              <Controller
                render={(rp) => (
                  <TextField
                    name="createName"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label="创建者"
                    defaultValue=""
                    value={rp.value ?? createByValue}
                    onChange={(e) => {
                      setValue('createName', e.target.value);
                      setCreateByValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('createName', '');
                              setCreateByValue('');
                            }}
                            edge="end"
                          >
                            {createByValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="createName"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label="创建者"
                defaultValue=""
              />
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              重置
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: 'btn_user_profile_management_list_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              查询
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
});

export default SearchGroup;
